module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "toc"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fmh1"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_tp_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_ded_r1"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_ack_r1"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_prf_r1"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_itr_r1"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cpt"
  }, [_c('a', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_p01_r1"
    }
  }, [_vm._v("PART ONE - Physicians Must Be Altruistic")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c01_r1"
    }
  }, [_vm._v("OUTPATIENT")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c02_r1"
    }
  }, [_vm._v("from FIRST SERMON ON REVERENCE FOR LIFE")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c03_r1"
    }
  }, [_vm._v("LIKE A PRAYER")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c04_r1"
    }
  }, [_vm._v("THE BODY FLUTE")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c05_r1"
    }
  }, [_vm._v("CAN YOU TEACH COMPASSION?")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c06_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1852: J. MARION SIMS PERFECTS A REPAIR FOR VESICOVAGINAL FISTULA")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c07_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("from THE NAZI DOCTORS")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c07_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOTES")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c08_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE LIE")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c09_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE WOUND DRESSER from Leaves of Grass")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c09_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c09_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c09_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c09_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c10_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE GOOD DOCTOR")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c11_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EPISODE OF HANDS")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c12_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("from DEEP RIVER")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cpt"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_p02_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART TWO - Physicians Must Be Knowledgeable")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c13_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE CADAVER")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c13_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c13_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c13_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c13_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c13_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c13_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c13_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c13_r1#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c13_r1#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c13_r1#h10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c13_r1#h11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c13_r1#h12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c14_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ANYUTA")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c15_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE MAN WITH STARS INSIDE HIM")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c16_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FROM THE HEART")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c17_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE SEDUCTIVE BEAUTY OF PHYSIOLOGY")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c17_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOTES")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c18_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("from PEOPLE LIKE THAT ARE THE ONLY PEOPLE HERE: CANONICAL BABBLING IN PEED ONK")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c19_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ADMISSION, CHILDREN’S UNIT")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c20_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE VILLAGE WATCHMAN")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c21_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("from THE ELEPHANT MAN: A PLAY")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c22_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LEECH, LEECH, ET CETERA")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c23_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BAPTISM BY ROTATION from A Country Doctor’s Notebook")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c24_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WHO OWNS THE LIBRETTO?")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cpt"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_p03_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART THREE - Physicians Must Be Skillful")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c25_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE TALLIS CASE")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c26_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("from MY OWN COUNTRY")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c27_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WHAT THE DOCTOR SAID")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c28_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THIS RED OOZING")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c29_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FROM THE LISTENING END OF THE STETHOSCOPE")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c30_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LARGE WOMAN, HALF")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c31_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE KNEE")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c32_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("from THE DIVING BELL AND THE BUTTERFLY")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c33_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LETTER FROM THE REHABILITATION INSTITUTE")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c34_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BREAST CANCER: POWER VS. PROSTHESIS from The Cancer Journals")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c35_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A SMALL, GOOD THING")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c36_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PIES")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c37_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("COMMUNION")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c38_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE NATURE OF SUFFERING AND THE GOALS OF MEDICINE")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c38_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Person” Is Not “Mind”")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c38_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Impending Destruction of Person")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c38_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Simplified Description of the Person")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c38_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Nature of Suffering")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c38_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Amelioration of Suffering")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c38_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("When Suffering Continues")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c39_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("REPOSE")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c40_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE GIRL WITH THE PIMPLY FACE")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c41_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HEALERS: THE PHYSICIAN AND THE MORI")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cpt"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_p04_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART FOUR -  Physicians Must Be Dutiful")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c42_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("from NOT ALL OF US ARE SAINTS")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c43_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IN TERROR OF HOSPITAL BILLS")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c44_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ANOTHER CASE OF CHRONIC PELVIC PAIN")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c45_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("from THE SCALPEL AND THE SILVER BEAR")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c46_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("UNWED")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c47_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("from A WISE BIRTH")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c48_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("from THE SPIRIT CATCHES YOU AND YOU FALL DOWN")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c49_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HEALTH IS MEMBERSHIP")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c50_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("from AN UNQUIET MIND")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c51_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A YOUNG PSYCHIATRIST LOOKS AT HIS PROFESSION from The Mind’s Fate")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c52_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("from THE TENNIS PARTNER")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c53_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FACING OUR MORALITY: THE VIRTUE OF A COMMON LIFE")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_c53_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOTES")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_bm1_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PERMISSIONS")])]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/robe_9781595587800_oeb_cop_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Page")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f07eb47","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/robe_9781595587800_oeb_toc_r1.vue
// module id = 60
// module chunks = 0